/**
 * Created by hernanherreros on 2019-05-29
 */

import * as React from 'react'
import { Request } from 'fetchboi'

export const createReservation = Request.register({
  endpoint: '/registrations',
  method: 'post',
})

export const getReservation = Request.register({
  endpoint: '/registrations/:id',
  method: 'get'
})

export const getCountDistinctInscription = Request.register({
  endpoint: '/inscriptions/countDistinct',
  method: 'post',
  useAuthentication: true,
})

export const saveRegistration = Request.register({
  endpoint: '/inscriptions/:id/information',
  method: 'put'
})

export const confirmRegistration = Request.register({
  endpoint: '/inscriptions/:id/confirm',
  method: 'put'
})

export const getGrantCompanies = Request.register({
  endpoint: '/grantCompanies?CongressSlug=:CongressSlug',
  method: 'get'
})

export const getInscriptionConfiguration = Request.register({
  endpoint: '/inscriptionConfigurations/:CongressSlug',
  method: 'get'
})

export const startPayment = Request.register({
  endpoint: '/inscriptions/:id/pay',
  method: 'put'
})

export const purchase = Request.register({
  endpoint: '/registrations/:id/purchase',
  method: 'put'
})

export const getPrices = Request.register({
  endpoint: '/registrations/prices?CongressSlug=:CongressSlug',
  method: 'get'
})

export const getPrice = Request.register({
  endpoint: '/registrations/prices?CongressSlug=:CongressSlug&UUID=:UUID',
  method: 'get'
})

export const saveCustomRegistration = Request.register({
  endpoint: '/inscriptions/:id/custom',
  method: 'put'
})

export const sendQRTicket = Request.register({
  endpoint: '/inscriptions/:uuid/sendQR',
  method: 'post',
})

export const getSegment = Request.register({
  endpoint: '/registrations/segments?CongressSlug=:CongressSlug&UUID=:uuid',
  method: 'get'
})

export const getDefaultSegment = Request.register({
  endpoint: '/registrations/segments?CongressSlug=:CongressSlug&Default=True',
  method: 'get'
})
